// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReferralSuccess_dialogPaper__I4sep {
  border-radius: 20px !important;
  max-width: 610px !important;
}

.ReferralSuccess_content__C7Vci {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 54px 64px;
  gap: 32px;
}

.ReferralSuccess_icon__IM6uE {
  width: 32px;
  height: 32px;
}

.ReferralSuccess_message__x1DyR {
  font-family: Inter;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: center;
  color: #808080;
  margin: 0;
}

.ReferralSuccess_closeButton__sPW9A {
  border: 2px solid #EBEBEB;
  padding: 12px 48px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  background: #FFFFFF;
  font-family: Inter;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ReferralSuccess_closeButton__sPW9A:hover {
  background: #F5F5F5;
}

@media (max-width: 480px) {
  .ReferralSuccess_content__C7Vci {
    padding: 40px 24px;
    gap: 24px;
  }

  .ReferralSuccess_message__x1DyR {
    font-size: 14px;
    line-height: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/CheckoutPage/ReferralSuccess/index.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".dialogPaper {\n  border-radius: 20px !important;\n  max-width: 610px !important;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 54px 64px;\n  gap: 32px;\n}\n\n.icon {\n  width: 32px;\n  height: 32px;\n}\n\n.message {\n  font-family: Inter;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.01em;\n  text-align: center;\n  color: #808080;\n  margin: 0;\n}\n\n.closeButton {\n  border: 2px solid #EBEBEB;\n  padding: 12px 48px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);\n  border-radius: 16px;\n  background: #FFFFFF;\n  font-family: Inter;\n  font-weight: 500;\n  font-size: 16px;\n  color: #333333;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.closeButton:hover {\n  background: #F5F5F5;\n}\n\n@media (max-width: 480px) {\n  .content {\n    padding: 40px 24px;\n    gap: 24px;\n  }\n\n  .message {\n    font-size: 14px;\n    line-height: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogPaper": `ReferralSuccess_dialogPaper__I4sep`,
	"content": `ReferralSuccess_content__C7Vci`,
	"icon": `ReferralSuccess_icon__IM6uE`,
	"message": `ReferralSuccess_message__x1DyR`,
	"closeButton": `ReferralSuccess_closeButton__sPW9A`
};
export default ___CSS_LOADER_EXPORT___;
